<template>
    <div class="wrap">
    <div class="loginImgBox">
        <img src="../../assets/image/system/login.png" alt="">
    </div>


<div class="formdata">
<div class="inputBox">
    <input type="text" placeholder="请输入你的推荐人工号">
</div>

<div class="btnBox">
    <button>登&nbsp &nbsp录</button>
</div>

</div>
 


    </div>

   

</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.wrap{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
}
.loginImgBox{
    width: 2rem;
    height: 2rem;
        position: absolute;
    top: 30%;
    right: 50%;
    transform: translate(50%, -50%);
    
    img{
        width:100%;
        height: 100%;
    }

}

.formdata{
    padding: 0rem 0.7rem;
    box-sizing: border-box;
   
     position: absolute;
    top: 57%;
    right: 50%;
    transform: translate(50%, -50%);
    
.inputBox{
input{
    height: 1rem;
    width: 6rem;
    background-color: rgb(245,245,245);
    border: 0rem solid transparent;
    border-radius: 0.2rem;
}

}

.btnBox{
    width: 4rem;
    height: 0.88rem;
    margin: 0.81rem auto;
    button{
        width: 100%;
        height: 100%;
        background-color: rgb(77,205,112);
        border-radius: 0.2rem;
        border: 0px solid transparent;
        color: rgb(255,255,255);
        font-size: 0.3rem;
        // letter-spacing:0.rem;
    }
}
}
</style>
